import { useMemo } from 'react';

import meanBy from 'lodash/meanBy';

import { useInventoryWorkloadsMetrics } from '../../_hooks/useInventoryWorkloadsMetrics';

export type ReclaimedResourceItem = {
  originalReq: number;
  req: number;
  rec: number;
  usage: number;
  diff: number;
};

export type ReclaimedResourcesData = {
  cpu: ReclaimedResourceItem | undefined;
  memory: ReclaimedResourceItem | undefined;
};

export const useReclaimedResourcesData = () => {
  const { dataOrFixture, isLoading, isFetching, error, refetch } =
    useInventoryWorkloadsMetrics();

  const data = useMemo<ReclaimedResourcesData | undefined>(() => {
    if (!dataOrFixture) return undefined;

    const computeAverages = (
      items: typeof dataOrFixture.cpu
    ): ReclaimedResourceItem => {
      const originalReq = meanBy(items, 'originalReq') ?? 0;
      const req = meanBy(items, 'req') ?? 0;
      const rec = meanBy(items, 'rec') ?? 0;
      const usage = meanBy(items, 'usage') ?? 0;
      return { originalReq, req, rec, usage, diff: originalReq - req };
    };

    return {
      cpu: dataOrFixture.cpu.length
        ? computeAverages(dataOrFixture.cpu)
        : undefined,
      memory: dataOrFixture.memory.length
        ? computeAverages(dataOrFixture.memory)
        : undefined,
    };
  }, [dataOrFixture]);

  return { data, isLoading, isFetching, error, refetch };
};
